import { useQuery } from 'react-query';
import axios from 'axios';
import { object, string } from 'yup';

import { apiConfig } from '@constants';

const coordsSchema = object({
  lat: string().required(),
  lng: string().required(),
});

type Coords = {
  lat: string;
  lng: string;
};

const getLocationFromCoords = async (coords: Coords) => {
  const { lat, lng } = await coordsSchema.validate(coords);

  const { data } = await axios.get(`${apiConfig.LOCAL_NOW_CITY_URL}?Latitude=${lat}&Longitude=${lng}`, {
    headers: {
      'X-API-KEY': apiConfig.LOCAL_NOW_API_KEY,
    },
  });

  return data;
};

export const useGetLocationFromCoords = ({ lat, lng }: Coords) =>
  useQuery(['getLocationFromCoords', lat, lng], () => getLocationFromCoords({ lat, lng }), {
    enabled: Boolean(lat && lng),
  });
